import { EXPORT_STATUS_DONE_STRING } from "actions/api/exports/actions";

/**
 * Export.
 *
 * @param {Object} params - Object parameter
 * @param {string} params.process - Kind of export you want
 * @param {int} params.id - Identifier of the export
 * @param {string} params.status - Status of the export
 * @param {string} params.dest - URL of the export
 * @constructor
 */

export default class Export {
	constructor({ process, id, status, dest } = {}) {
		this._process = process;
		this._id = id;
		this._status = status;
		this._dest = dest;
	}

	id() {
		return this._id;
	}

	toString() {
		return this.process();
	}

	process() {
		return this._process;
	}

	dest() {
		return this._dest;
	}

	isDone() {
		return this._status === EXPORT_STATUS_DONE_STRING;
	}
}
